var map = {
	"./1-1.png": "2d35",
	"./1-2.png": "fb86",
	"./1-3.png": "72cd",
	"./1-4.png": "dbff",
	"./1-5.png": "4113",
	"./1-6.png": "8244",
	"./1.png": "bd0f",
	"./2-1.png": "1ca6",
	"./2-2.png": "b5ec",
	"./2-3.png": "cafb",
	"./2-4.png": "5093",
	"./2-5.png": "ff48",
	"./2-6.png": "06e4",
	"./2.png": "c38c",
	"./3-1.png": "6f2e",
	"./3-2.png": "5c9c",
	"./3-3.png": "0718",
	"./3-4.png": "cb85",
	"./3-5.png": "3f11",
	"./3-6.png": "4975",
	"./3.png": "5b0d",
	"./4-1.png": "090f",
	"./4-2.png": "fec8",
	"./4-3.png": "dc53",
	"./4-4.png": "0bc6",
	"./4-5.png": "679c",
	"./4.png": "2e50"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6370";